import http from './http'

export async function getGuide(id, size = 10) {
    return await http.get("/guide", { params: { "guide-id": id, "size": size } }).then(response => {
        if (response.status === 200) {
            return response
        }
    }).catch(() => console.error("가이드 정보를 얻는데 실패했습니다."))
}

export async function getGuideDetail(id) {
    return await http.get("/guide/detail", { params: { "guide-id": id } }).then(response => {
        if (response.status === 200) {
            return response
        }
    }).catch(() => console.error("가이드 정보를 얻는데 실패했습니다."))
}

export async function postGuide(request) {
    return await http.post("/admin/guide", JSON.stringify(request)).then(response => {

        if (response.status === 201) {
            return response
        }
    }).catch(() => console.error("가이드 생성에 실패했습니다."))

}

export async function editGuide(request) {
    return await http.put("/admin/guide", JSON.stringify(request)).then(response => {

        if (response.status === 200) {
            return response
        }
    }).catch(() => console.error("가이드 수정에 실패했습니다."))
}

export async function deleteGuide(id) {
    return await http.delete("/admin/guide", { params: { "guide-id": id } }).then(response => {
        if (response.status === 200 || response.status === 204) {
            return response
        }
    }).catch(() => console.error("가이드 삭제에 실패했습니다."))
}